import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { createHealthieAccountChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const CreateHealthieAccountChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={createHealthieAccountChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default CreateHealthieAccountChannel;
